// LaunchSequence.jsx
import React, { useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "./ui/card.tsx";
import "./LaunchSequence.css";

const LaunchSequence = ({ onComplete, onNameSet }) => {
  const [step, setStep] = useState("naming");
  const [companyName, setCompanyName] = useState("");
  const [error, setError] = useState("");
  //   const [displayedMessages, setDisplayedMessages] = useState([]);

  const handleNameSubmit = (e) => {
    e.preventDefault();
    if (companyName.length === 0) {
      setError("Please enter a name");
      return;
    }
    if (companyName.length > 15) {
      setError("Name must be 15 characters or less");
      return;
    }
    setError("");
    onNameSet(companyName);
    setStep("launch");
  };

  const handleLaunch = () => {
    setStep("");
    onComplete();
  };

  if (step === "naming") {
    return (
      <div className="launch-sequence-overlay">
        <Card className="launch-modal">
          <CardHeader>
            <CardTitle className="launch-title">
              Congratulations on creating a brand new social media!
            </CardTitle>
          </CardHeader>
          <CardContent>
            <div className="launch-content">
              <p className="launch-description">
                You've put in the work and now all that's left is to name your
                brand new platform.
              </p>
              <form onSubmit={handleNameSubmit} className="name-form">
                <div className="input-container">
                  <input
                    type="text"
                    maxLength={15}
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                    placeholder="Enter platform name"
                    className="name-input"
                  />
                  {error && <div className="error-message">{error}</div>}
                </div>
                <button type="submit" className="submit-button">
                  Next
                </button>
              </form>
            </div>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (step === "launch") {
    return (
      <div className="launch-sequence-overlay">
        <Card className="launch-modal">
          <CardHeader>
            <CardTitle>Ready for Launch</CardTitle>
          </CardHeader>
          <CardContent>
            <p>
              With one final click, you'll put {companyName} on the app store.
              All the hard work is done.
            </p>
            <button onClick={handleLaunch} className="launch-button">
              Revel in Glory
            </button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return null;
};

export default LaunchSequence;

// const INITIAL_MESSAGES = [
//   "Just found this cool new app!",
//   "No ads, clean interface... this might be my new favorite",
//   "Finally, a social media that's not trying to sell me stuff",
//   "Already told my friends about it 😊",
//   "Love how simple everything is",
//   "Can't wait to see this community grow!",
// ];

// const LaunchSequence = ({ onComplete, onNameSet }) => {
//   const [step, setStep] = useState("naming");
//   const [companyName, setCompanyName] = useState("");
//   const [error, setError] = useState("");
//   const [showMessages, setShowMessages] = useState(false);
//   const [displayedMessages, setDisplayedMessages] = useState([]);

//   const handleNameSubmit = (e) => {
//     e.preventDefault();
//     if (companyName.length === 0) {
//       setError("Please enter a name");
//       return;
//     }
//     if (companyName.length > 15) {
//       setError("Name must be 15 characters or less");
//       return;
//     }
//     setError("");
//     onNameSet(companyName);
//     setStep("launch");
//   };

//   const handleLaunch = () => {
//     setStep("messages");
//     setShowMessages(true);
//   };

//   // Handle message sequence
//   useEffect(() => {
//     if (showMessages) {
//       let messageIndex = 0;
//       const interval = setInterval(() => {
//         if (messageIndex < INITIAL_MESSAGES.length) {
//           setDisplayedMessages((prev) => [
//             ...prev,
//             INITIAL_MESSAGES[messageIndex],
//           ]);
//           messageIndex++;
//         } else {
//           clearInterval(interval);
//           setTimeout(() => {
//             onComplete();
//           }, 1000); // Wait a second after last message before completing
//         }
//       }, 1000);

//       return () => clearInterval(interval);
//     }
//   }, [showMessages, onComplete]);

//   if (step === "naming") {
//     return (
//       <div className="launch-sequence-overlay">
//         <Card className="launch-modal">
//           <CardHeader>
//             <CardTitle>Congratulations!</CardTitle>
//           </CardHeader>
//           <CardContent>
//             <div className="launch-content">
//               <p className="launch-description">
//                 You've put in the work and now all that's left is to name your
//                 brand new social media platform!
//               </p>
//               <form onSubmit={handleNameSubmit} className="name-form">
//                 <div className="input-wrapper">
//                   <input
//                     type="text"
//                     maxLength={15}
//                     value={companyName}
//                     onChange={(e) => setCompanyName(e.target.value)}
//                     placeholder="Enter platform name"
//                     className="name-input"
//                   />
//                   {error && <div className="error-message">{error}</div>}
//                 </div>
//                 <button type="submit" className="submit-button">
//                   Next
//                 </button>
//               </form>
//             </div>
//           </CardContent>
//         </Card>
//       </div>
//     );
//   }

//   if (step === "launch") {
//     return (
//       <div className="launch-sequence-overlay">
//         <Card className="launch-modal">
//           <CardHeader>
//             <CardTitle>Ready for Launch</CardTitle>
//           </CardHeader>
//           <CardContent>
//             <p>
//               With one final click, you'll put {companyName} on the app store.
//               All the hard work is done.
//             </p>
//             <button onClick={handleLaunch} className="launch-button">
//               Revel in Glory
//             </button>
//           </CardContent>
//         </Card>
//       </div>
//     );
//   }

//   if (step === "messages") {
//     return (
//       <div className="initial-messages">
//         {displayedMessages.map((message, index) => (
//           <div key={index} className="message-bubble">
//             {message}
//           </div>
//         ))}
//       </div>
//     );
//   }

//   return null;
// };

// export default LaunchSequence;
